export const projects = {
    titleOne: {
        project: 'Zyante',
        url: 'https://zyante.vercel.app/',
        description: 'Interactive scene inspired by the Day of the Dead',
        tags: 'Post-processing / Interaction / Shader'
    }, 
    titleTwo: {
        project: 'Bean Collision',
        url: 'https://bean-collision.vercel.app/',
        description: 'Interactive 3D scene with physics-driven coffee beans.', 
        tags: 'Post-processing / Interaction / Rapier'
    },
    titleThree: {
        project: 'Kitchen Configurator',
        url: 'https://webgl-kitchen-configurator3d.vercel.app/',
        description: 'Prototype for texture changes. This project was my first hands-on experience with Three.js and sparked my passion for 3D web development.', 
        tags: 'Texture Mapping / Interactive Prototype'
    },
    titleFour: {
        project: 'Project Galaxy',
        url: 'https://galaxy-eight-brown.vercel.app/',
        description: 'Interactive 3D presentation of a smartphone where scrolling animates the device.', 
        tags: 'Shader / Post-processing / Interaction / UI / Product Configurator'
    }, 
    titleFive: {
        project: 'Ascend',
        url: 'https://ascend-blue.vercel.app/',
        description: 'Atmospheric 3D meditation scene focused on light, balance, and calm. A single model floats in a blue-lit space enhanced by post-processing effects.', 
        tags: 'Post-processing'
    },
    titleSix: {
        project: 'Moka Pot',
        url: 'https://moka-pot.vercel.app/',
        description: 'Visual study of light, form, and coffee.', 
    },
    titleSeven: {
        project: 'Tropic Step',
        url: 'https://tropic-step.vercel.app/',
        description: 'Interactive 3D experiment where shoes fall and colliding dynamically.', 
        tags: 'Cannon.js / Interaction'
    }
}

export const contact = {
    stickerInstagram: {
        url: 'https://www.instagram.com/dani_torresa/'
    },
    stickerLinkedin: {
        url: 'https://www.linkedin.com/in/daniela-t-891921180/'
    },
    stickerGmail: {
        url: 'mailto:danielatorresara@gmail.com'
    }
}

